import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { COUNTRY } from 'common/constants';
import { selectDataCountry, selectDataMatchQualityTier } from 'connect/selectors';
import { CheckoutInsurancePlan, CheckoutInsuranceProvider } from 'pages/checkout/connect/types';
import { getInNetworkStatus } from 'pages/common/helpers/common-helpers';
import { useHookResult } from 'utils/customHooks/use-hook-result';

interface MatchQualityTierClinic {
  insurancePlans?: number[] | null;
}

interface MatchQualityTierParams {
  clinics: MatchQualityTierClinic[];
  insuranceProvider?: CheckoutInsuranceProvider | null;
  insurancePlan?: CheckoutInsurancePlan | null;
}

export const useMatchQualityTierTrackingData = (params: MatchQualityTierParams) => {
  const { clinics, insuranceProvider, insurancePlan } = params;

  const country = useSelector(selectDataCountry);
  const matchQualityTier = useSelector(selectDataMatchQualityTier);
  const isInNetwork = useMemo(() => {
    const isInCanada = country === COUNTRY.canada;
    if (isInCanada) {
      return Boolean(insuranceProvider?.id);
    }

    return clinics.some((clinic) => getInNetworkStatus(insurancePlan?.id, clinic.insurancePlans));
  }, [clinics, insurancePlan?.id, country, insuranceProvider?.id]);

  const insuranceProviders = useMemo(
    () => insuranceProvider ? [insuranceProvider.name] : undefined,
    [insuranceProvider],
  );

  return useHookResult({
    matchQualityTier,
    isInNetwork,
    insuranceProviders,
  });
};
